'use client';
import type { ReactNode } from 'react';
import { SilkSheet } from '@/components/ui/silk-sheet';
import type { useFundingChrome } from './funding-chrome';
import { FundingDialogFooter, FundingDialogHeader } from './funding-dialog-chrome';

export function FundingDialog({
  open,
  onClose,
  onHistory,
  onProfile,
  chrome,
  children,
  history = false,
  direct = false,
  provider = 'moonpay',
}: {
  open: boolean;
  history?: boolean;
  direct?: boolean;
  provider?: 'moonpay' | 'morfi';
  onClose(): void;
  onHistory(): void;
  onProfile?: (() => void) | undefined;
  chrome: ReturnType<typeof useFundingChrome>;
  children: ReactNode;
}): ReactNode {
  return (
    <SilkSheet
      open={open}
      onOpenChange={(open: boolean): void => {
        if (!open) onClose();
      }}
      title={chrome.title}
      header={<FundingDialogHeader chrome={chrome} onClose={onClose} />}
      closeButton={false}
      disableDesktopSwipe
      variant="detached"
      size="md"
      contentClassName="pt-0 sm:pt-0"
      footerClassName="shrink-0 border-t-[1px]"
      sheetClassName={
        history
          ? 'funding-dialog-height scrollbar-none [&_*]:scrollbar-none sm:max-w-170'
          : 'funding-dialog-height scrollbar-none [&_*]:scrollbar-none sm:max-w-md'
      }
      footer={
        <FundingDialogFooter
          chrome={chrome}
          onHistory={onHistory}
          onProfile={onProfile}
          direct={direct}
          provider={provider}
        />
      }
    >
      {children}
    </SilkSheet>
  );
}
